/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：elementUIの配置
 *
 * 作成者：2021/11/19 ノア）黄
 * 最終修正者：2021/11/19 ノア）黄
 *
 */
import Vue from 'vue'
import {
  Button,
  Table,
  TableColumn,
  Card,
  Select,
  Option,
  DatePicker,
  Input,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Icon,
  Dialog,
  Tree,
  Avatar,
  Popover,
  Menu,
  MenuItem,
  MenuItemGroup,
  Submenu,
  Badge,
  Tooltip,
  Cascader,
  Switch,
  Tabs,
  TabPane,
  Checkbox,
  Step,
  Steps,
  Radio,
  RadioGroup,
  TimePicker,
  Collapse,
  CollapseItem,
  Message,
  Pagination,
  Upload
} from 'element-ui'
import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'

locale.use(lang)

Vue.use(Button)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Card)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(Input)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Icon)
Vue.use(Dialog)
Vue.use(Tree)
Vue.use(Avatar)
Vue.use(Popover)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Submenu)
Vue.use(Badge)
Vue.use(Tooltip)
Vue.use(Cascader)
Vue.use(Switch)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Checkbox)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(TimePicker)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Pagination)
Vue.use(Upload)

Vue.prototype.$message = Message
